import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';

import { SET_RECONNECTION_STATUS } from 'modules/conference/actions/consultationLifecycle';
import { STOP_CONSULTATION, STOP_CONSULTATION_LOCAL, HIDE_FINISHED_CONSULTATION } from '../actions/stopConsultation';
import {
  SET_UPSTREAM_CONNECTION_STATUS,
  SET_DOWNSTREAM_CONNECTION_STATUS,
} from '../actions/setConnectionStatus';

const defaultState = {
  upstream: undefined,
  downstream: undefined,
};

export default createReducer(defaultState, {
  [SET_UPSTREAM_CONNECTION_STATUS]: (state, { meta: { status } }) => ({
    ...state,
    upstream: status,
  }),

  [SET_DOWNSTREAM_CONNECTION_STATUS]: (state, { meta: { status } }) => ({
    ...state,
    downstream: status,
  }),

  [SET_RECONNECTION_STATUS]: (state) => ({
    ...state,
    downstream: undefined,
  }),

  [HIDE_FINISHED_CONSULTATION]: () => defaultState,
  [STOP_CONSULTATION.success]: () => defaultState,
  [STOP_CONSULTATION_LOCAL]: () => defaultState,

  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
